require("./bootstrap");

// Components
// require("./components/animation");
// require("./components/disclaimer");
// require("./components/colorbox");
// require("./components/post");
// require("./components/utilities");

// Blocks
require("./blocks/accordion");
require("./blocks/content-box");
require("./blocks/masthead");
require("./blocks/responsive-slider");
require("./blocks/stats");
require("./blocks/tabs");
require("./blocks/wp-menu");

import "./header.js";
import { onScrollDirection } from "./utilities/scrolling.js";

/* =====================================
Module Dynamic import
======================================== */

document.addEventListener("DOMContentLoaded", async () => {
  //global videos
  if (document.getElementsByClassName("js-has-video")) {
    const { globalVideos } = await import("./global/video.js");
    globalVideos();
  }

  //global accordion
  if (document.querySelector(".os-accordion")) {
    const { createAccordion } = await import("./global/accordion.js");
    createAccordion();
  }

  if (document.querySelector(".content-image-carousel")) {
    const { contentImageCarousel } = await import(
      "./blocks/content-image-carousel.js"
    );
    contentImageCarousel();
  }

  if (document.querySelector(".team-testimonial")) {
    const { teamTestimonial } = await import("./blocks/team-testimonials.js");
    teamTestimonial();
  }

  if (document.querySelector(".project-filter")) {
    const { projectFilter } = await import("./blocks/project-filter.js");
    projectFilter();
  }

  if (document.querySelector(".js-filter-module")) {
    const { default: FilterHandler } = await import("./filters.js");
    new FilterHandler();
  }

  if (document.querySelector(".js-filter-newsletter-module")) {
    const { default: FilterHandler } = await import("./filter-newsletters.js");
    new FilterHandler();
  }

  if (document.querySelector(".js-filter-module-cc")) {
    const { default: FilterHandlerCC } = await import("./filter-cc.js");
    new FilterHandlerCC();
  }

  if (document.getElementById("stickySubnav")) {
    const { subnav } = await import("./global/sub-nav.js");
    subnav();
  }

  if (document.querySelector("[os-scrollspy]")) {
    const { customScrollSpy } = await import("./global/os-scrollspy.js");
    customScrollSpy();
  }

  if (document.getElementById("remaining-resources")) {
    const { remainingResources } = await import(
      "./blocks/past-meeting-resources.js"
    );
    remainingResources();
  }

  if (document.querySelector(".ninja-form")) {
    const { initStatesCounties } = await import("./global/statesCountries.js");
    const { initUTMTracking } = await import("./forms/utmTracking.js");
    const { initResponsiveAccordions } = await import("./global/ninja-accordion.js");
    const { initNinjaDate } = await import("./global/ninja-date.js");
    const { initRadioListToggle } = await import("./forms/radiolist.js");
    initStatesCounties();
    initUTMTracking();
    initResponsiveAccordions();
    initNinjaDate();
    initRadioListToggle();
  }

  // Example usage: log scroll direction
  onScrollDirection((direction) => {
    if (direction == "down") {
      document.documentElement.classList.add("is-scrolling-down");
      document.documentElement.classList.remove("is-scrolling-up");
    } else {
      document.documentElement.classList.add("is-scrolling-up");
      document.documentElement.classList.remove("is-scrolling-down");
    }
  });
});
